<app-navbar
  [headerText]="'Mənfəət və Zərər'"
  [buttons]="navButtons"
  [dataLoading]="dataLoading"
></app-navbar>

<div class="container-fluid px-3">
  <div class="row mt-6 justify-content-center">
    <div class="col-md-6">
      @if(status) {
      <div>
        <!-- <div
          class="mb-3 d-flex gap-2 card py-2 px-3"
          style="
            font-size: small;
            border: none;
            box-shadow: 0px 0px 4px #0000002e;
          "
        >
          <div class="d-flex justify-content-between w-100">
            <span>Period</span>
            <div class="ms-auto">
              <span>{{
                _dataService.startDate.value
                  | date : "d MMMM yyyy" : "" : "az-Latn"
              }}</span>
              <span> - </span>
              <span>{{
                (_dataService.endDate.value &&
                now.isBefore(_dataService.endDate.value)
                  ? now.toDate()
                  : _dataService.endDate.value
                  ? _dataService.endDate.value.toDate()
                  : null
                ) | date : "d MMMM yyyy" : "" : "az-Latn"
              }}</span>
            </div>
          </div>
          <hr class="my-0" />
          <div class="d-flex justify-content-between w-100">
            <span>Ötən period</span>
            <div class="ms-auto">
              <span>{{
                status.previousPeriodRange.startDate
                  | date : "d MMMM yyyy" : "" : "az-Latn"
              }}</span>
              <span> - </span>
              <span>{{
                status.previousPeriodRange.endDate
                  | date : "d MMMM yyyy" : "" : "az-Latn"
              }}</span>
            </div>
          </div>
        </div> -->

        <div class="revenueTable mt-3">
          <div
            class="d-flex justify-content-between cursor-pointer"
            (click)="bankTransactionsDialog('sells')"
          >
            <span>Satışlar</span>
            <div class="changes">
              @if(status.currentPeriod.sellsAnalysis.sellsCurrentPeriod -
              status.prevPeriod.sellsAnalysis.sellsCurrentPeriod >0){
              <span class="material-symbols-outlined theArrow">
                arrow_upward
              </span>
              } @else {
              <span class="material-symbols-outlined theArrow">
                arrow_downward
              </span>
              }
              <span style="font-size: small">{{
                status.currentPeriod.sellsAnalysis.sellsCurrentPeriod -
                  status.prevPeriod.sellsAnalysis.sellsCurrentPeriod
                  | number : "1.0-0"
                  | negativeNumberToPositive
                  | commaToSpace
              }}</span>
            </div>
          </div>
          <div
            style="position: relative"
            class="cursor-pointer"
            (click)="bankTransactionsDialog('sells')"
          >
            <span>{{
              status.currentPeriod.sellsAnalysis.sellsCurrentPeriod | number
            }}</span>
          </div>
          <span class="sub">Material dəyəri</span>
          <span class="sub">{{ maliyyet | number }}</span>
          <div
            (click)="bankTransactionsDialog('sellsIncome')"
            class="d-flex mt-3 cursor-pointer justify-content-between noWrap"
          >
            <span>Satışdan gələn</span>
            <div class="changes">
              @if( status.currentPeriod.bankAnalysis.incomesByCategory[0]?.in -
              status.prevPeriod.bankAnalysis.incomesByCategory[0]?.in >0){
              <span class="material-symbols-outlined theArrow">
                arrow_upward
              </span>
              } @else {
              <span class="material-symbols-outlined theArrow">
                arrow_downward
              </span>
              }
              <span style="font-size: small">{{
                status.currentPeriod.bankAnalysis.incomesByCategory[0]?.in -
                  status.prevPeriod.bankAnalysis.incomesByCategory[0]?.in
                  | number : "1.0-0"
                  | negativeNumberToPositive
                  | commaToSpace
              }}</span>
            </div>
          </div>
          <span
            class="mt-3 cursor-pointer"
            (click)="bankTransactionsDialog('sellsIncome')"
            >{{
              status.currentPeriod.bankAnalysis.incomesByCategory[0]?.in
                | number
            }}</span
          >
          @if(otherIncome!=0){
          <span
            class="sub text-dark"
            (click)="bankTransactionsDialog('otherIncome')"
            >Digər alınan ödənişlər</span
          >
          <span
            class="sub text-dark"
            (click)="bankTransactionsDialog('otherIncome')"
            >{{ otherIncome | number }}</span
          >
          }
          <span class="sub" (click)="bankTransactionsDialog('xammalPayments')"
            >Xammal ödənişləri</span
          >
          <span
            class="sub"
            (click)="bankTransactionsDialog('xammalPayments')"
            >{{ xammalPayments | number }}</span
          >
          <span class="sub" (click)="bankTransactionsDialog('expenses')"
            >Xərclər</span
          >
          <span class="sub" (click)="bankTransactionsDialog('expenses')">{{
            status.currentPeriod.profitAndLossPeriod
              .periodAdministrativeExpenses - xammalIncomes | number
          }}</span>
          @if(status.currentPeriod.profitAndLossPeriod.otherExpenses!= 0) {
          <span class="sub" (click)="bankTransactionsDialog('otherExpenses')"
            >Digər Ödənişlər</span
          >
          <span class="sub" (click)="bankTransactionsDialog('otherExpenses')">{{
            status.currentPeriod.profitAndLossPeriod.otherExpenses | number
          }}</span>
          }
          <div class="d-flex justify-content-between">
            <span>Gəlir</span>
          </div>
          <!-- GELIR -->
          <span>{{
            status.currentPeriod.bankAnalysis.incomesByCategory[0]?.in -
              xammalPayments +
              xammalIncomes -
              status.currentPeriod.profitAndLossPeriod
                .periodAdministrativeExpenses -
              status.currentPeriod.profitAndLossPeriod.otherExpenses +
              otherIncome | number
          }}</span>
          <span class="sub" (click)="bankTransactionsDialog('menfeet')"
            >Mənfəət ödənişləri</span
          >
          <span class="sub" (click)="bankTransactionsDialog('menfeet')">{{
            menfeet | number
          }}</span>
          <span>Yekun</span>
          <span>{{
            status.currentPeriod.bankAnalysis.incomesByCategory[0]?.in -
              xammalPayments +
              xammalIncomes -
              status.currentPeriod.profitAndLossPeriod
                .periodAdministrativeExpenses -
              menfeet -
              status.currentPeriod.profitAndLossPeriod.otherExpenses +
              otherIncome | number
          }}</span>
        </div>
        <hr />
        <div class="revenueTable mt-3">
          <div class="d-flex justify-content-between">
            <span>Alacaq - Verəcək</span>
          </div>
          <span>{{
            status.currentPeriod.customerBalances.totalAccountsReceivable -
              status.currentPeriod.customerBalances.totalCustomerCreditsPayable
              | number
          }}</span>
          <div class="d-flex justify-content-between sub">
            <span>Alacaq</span>
            <div class="changes">
              @if( status.currentPeriod.customerBalances.totalAccountsReceivable
              - status.prevPeriod.customerBalances.totalAccountsReceivable >0){
              <span class="material-symbols-outlined theArrow">
                arrow_upward
              </span>
              } @else {
              <span class="material-symbols-outlined theArrow">
                arrow_downward
              </span>
              }
              <span style="font-size: small">{{
                status.currentPeriod.customerBalances.totalAccountsReceivable -
                  status.prevPeriod.customerBalances.totalAccountsReceivable
                  | number : "1.0-0"
                  | negativeNumberToPositive
                  | commaToSpace
              }}</span>
            </div>
          </div>
          <span class="sub">{{
            status.currentPeriod.customerBalances.totalAccountsReceivable
              | number
          }}</span>
          <div class="d-flex justify-content-between sub">
            <span>Verəcək</span>
            <div class="changes">
              @if(
              status.currentPeriod.customerBalances.totalCustomerCreditsPayable
              - status.prevPeriod.customerBalances.totalCustomerCreditsPayable
              >0){
              <span class="material-symbols-outlined theArrow">
                arrow_upward
              </span>
              } @else {
              <span class="material-symbols-outlined theArrow">
                arrow_downward
              </span>
              }
              <span style="font-size: small">{{
                status.currentPeriod.customerBalances
                  .totalCustomerCreditsPayable -
                  status.prevPeriod.customerBalances.totalCustomerCreditsPayable
                  | number : "1.0-0"
                  | negativeNumberToPositive
                  | commaToSpace
              }}</span>
            </div>
          </div>
          <span class="sub">{{
            status.currentPeriod.customerBalances.totalCustomerCreditsPayable
              | number
          }}</span>
        </div>
        <hr />
        <div class="revenueTable my-3">
          <div class="d-flex justify-content-between">
            <span>Anbar Dəyərləri</span>
          </div>
          <span>&nbsp;</span>
          <div class="d-flex justify-content-between sub">
            <span>Material Anbar Dəyəri</span>
            <div class="changes">
              @if(status.currentPeriod.inventoryValues.currentTotalMaterialsValue
              - (status.prevPeriod.inventoryValues?.currentTotalMaterialsValue
              || 0) > 0) {
              <span class="material-symbols-outlined theArrow"
                >arrow_upward</span
              >
              } @else {
              <span class="material-symbols-outlined theArrow"
                >arrow_downward</span
              >
              }
              <span style="font-size: small"
                >{{
                  status.currentPeriod.inventoryValues
                    .currentTotalMaterialsValue -
                    (status.prevPeriod.inventoryValues
                      ?.currentTotalMaterialsValue || 0)
                    | number : "1.0-0"
                    | negativeNumberToPositive
                    | commaToSpace
                }}
                ({{ status.percentageChanges.totalMaterialsStockValue }}%)
              </span>
            </div>
          </div>
          <span class="sub">{{
            status.currentPeriod.inventoryValues.currentTotalMaterialsValue
              | number
          }}</span>

          <div class="d-flex justify-content-between sub">
            <span>Hazır Məhsul Anbar Dəyəri</span>
            <div class="changes">
              @if(status.currentPeriod.inventoryValues.currentTotalProductsValue
              - (status.prevPeriod.inventoryValues?.currentTotalProductsValue ||
              0) > 0) {
              <span class="material-symbols-outlined theArrow"
                >arrow_upward</span
              >
              } @else {
              <span class="material-symbols-outlined theArrow"
                >arrow_downward</span
              >
              }
              <span style="font-size: small"
                >{{
                  status.currentPeriod.inventoryValues
                    .currentTotalProductsValue -
                    (status.prevPeriod.inventoryValues
                      ?.currentTotalProductsValue || 0)
                    | number : "1.0-0"
                    | negativeNumberToPositive
                    | commaToSpace
                }}
                ({{ status.percentageChanges.totalProductsStockValue }}%)
              </span>
            </div>
          </div>
          <span class="sub">{{
            status.currentPeriod.inventoryValues.currentTotalProductsValue
              | number
          }}</span>
        </div>
      </div>
      } @else {
      <span class="d-flex justify-content-center mt-3">Yüklənir.. </span>

      }
    </div>
  </div>
</div>

<div class="container-fluid px-3 mt-3">
  <div class="row">
    <div id="targetTable" class="col-md-6" style="position: relative">
      <!-- <section
          class="filterSettings"
          *ngIf="showFilterOptions"
          [@slideInOut]="showFilterOptions ? 'in' : 'out'"
          [formGroup]="selectedCustomerGroups"
        >
          <div
            class="px-3 py-1"
            style="
              background-color: #0000000a;
              display: flex;
              font-family: 'Mulish';
              font-weight: 600;
              font-size: 18px;
            "
          >
            <span style="padding-left: 23px">Filter</span>
          </div>
          <div
            *ngFor="let item of _dataService.customerGroups()"
            class="filterItems"
          >
            <input
              class="form-check-input"
              type="checkbox"
              value="{{ item.name }}"
              id="{{ item.id }}"
              formControlName="{{ item.id }}"
            />
            <label
              style="cursor: pointer"
              class="form-check-label"
              for="{{ item.id }}"
              >{{ item.name }}</label
            >
          </div>
          <div class="px-3 py-2" style="background-color: #0000000a">
            <button
              class="btn btnDelete w-100"
              style="padding: 4px !important"
              (click)="showFilterOptions = false"
            >
              Bağla
            </button>
          </div>
        </section> -->
    </div>
    <!-- <div class="col-md-6 mt-smm-6">
        <mat-chip-listbox aria-label="Customer Types">
          <mat-chip-option
            selected
            (click)="setChipSelected($event.target.innerText)"
            >Tərəf-Müqabillər
            <span class="balanceSums">{{
              _customersService.sumDebit + _customersService.sumKredit
                | number
                
            }}</span>
            <span
              class="manat"
              style="font-size: 10px !important; text-align: center"
              >₼</span
            ></mat-chip-option
          >
          <mat-chip-option (click)="setChipSelected('Debitorlar')"
            >Debitorlar
            <span class="balanceSums">{{
              _customersService.sumDebit | number
            }}</span>
            <span
              class="manat"
              style="font-size: 10px !important; text-align: center"
              >₼</span
            ></mat-chip-option
          >
          <mat-chip-option (click)="setChipSelected('Kreditorlar')"
            >Kreditorlar
            <span class="balanceSums">{{
              (-_customersService.sumKredit | number) || 0
            }}</span>
            <span
              class="manat"
              style="font-size: 10px !important; text-align: center"
              >₼</span
            ></mat-chip-option
          >
        </mat-chip-listbox>
        <!-- <div class="summary">
          <span>Alınan {{ _bankService.totalIn | number }} <span class="manat">₼</span></span>
          <span>Ödənən {{ _bankService.totalOut | number }} <span class="manat">₼</span></span>
          <span>Fərq {{ _bankService.totalIn - _bankService.totalOut | number }} <span class="manat">₼</span></span>
        </div>
      </div> -->
  </div>
</div>

<ng-template #tableDialogTemplate let-dialogData>
  <div
    class="ui-titlebar"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
    style="margin-bottom: -1px; z-index: 2; border-bottom: 1px solid"
  >
    <div class="ui-titletext">
      <span style="text-wrap: nowrap"> {{ dialogData.title }} </span>
    </div>
    <div class="ui-titlecontrols">
      <button class="ui-btn close" (click)="closeDialog()">
        <svg viewBox="0 0 10 10">
          <polygon
            points="10.2,0.7 9.5,0 5.1,4.4 0.7,0 0,0.7 4.4,5.1 0,9.5 0.7,10.2 5.1,5.8 9.5,10.2 10.2,9.5 5.8,5.1"
          />
        </svg>
      </button>
    </div>
  </div>

  <ag-table
    [rowData]="dialogData.tableData"
    [columnDefs]="dialogData.colDefs"
    [tableHeight]="dialogData.tableHeight"
    (rowClicked)="onAgTableRowClicked($event)"
    [tableClass]="'profitTable'"
  ></ag-table>
</ng-template>
